/**
 * RoomInfoPanel — right-side панель с метаданными активной комнаты:
 * тип, участники с online-точками, pinned-сообщение, последние медиа.
 *
 * Презентационная — клик по медиа/pinned уезжает наверх через
 * `onJumpToMessage` (там делается scrollIntoView + load history).
 */

import { resolveApiAssetUrl } from '../../../api/core'
import { isImageMessage } from '../../../utils/chatHelpers'
import { roleLabel, roomRoleLabel, roomTypeLabel } from '../../../utils/roleLabels'

export default function RoomInfoPanel({ room, messages, onJumpToMessage }) {
    if (!room) return null
    const participants = room.participants || []
    const media = (messages || []).filter((m) => m.file_url && isImageMessage(m)).slice(-24).reverse()
    const pinned = room.pinned_message

    return (
        <aside className="chat-room-info">
            <div className="chat-room-info__section">
                <h4 className="chat-room-info__title">О чате</h4>
                <div className="chat-room-info__meta">
                    <div><strong>Тип:</strong> {roomTypeLabel(room.type)}</div>
                    <div><strong>Участники:</strong> {participants.length}</div>
                </div>
            </div>

            <div className="chat-room-info__section">
                <h4 className="chat-room-info__title">Участники</h4>
                <div className="chat-room-info__participants">
                    {participants.map((p) => (
                        <div key={p.user_id} className="chat-room-info__participant">
                            <span className={`chat-room-info__dot ${p.is_online ? 'chat-room-info__dot--online' : ''}`} />
                            <span className="chat-room-info__participant-name">{p.name || p.user_id}</span>
                            {/* Метка = рабочая роль сотрудника; роль внутри комнаты добавляем
                                только модераторам, иначе у всех висело одинаковое `member`. */}
                            <span className="chat-room-info__participant-role" title={roleLabel(p.app_role)}>
                                {[roleLabel(p.app_role), roomRoleLabel(p.role)].filter(Boolean).join(' · ')}
                            </span>
                        </div>
                    ))}
                </div>
            </div>

            <div className="chat-room-info__section">
                <h4 className="chat-room-info__title">Pinned</h4>
                {pinned?.id ? (
                    <button
                        type="button"
                        className="chat-room-info__pinned"
                        onClick={() => onJumpToMessage?.(pinned.id)}
                    >
                        {(pinned.content || '').slice(0, 130) || pinned.file_name || 'Сообщение'}
                    </button>
                ) : (
                    <div className="chat-room-info__empty">Нет закрепленного сообщения</div>
                )}
            </div>

            <div className="chat-room-info__section">
                <h4 className="chat-room-info__title">Медиа</h4>
                {media.length ? (
                    <div className="chat-room-info__media-grid">
                        {media.map((m) => (
                            <button
                                key={m.id}
                                type="button"
                                className="chat-room-info__media-btn"
                                onClick={() => onJumpToMessage?.(m.id)}
                            >
                                <img src={resolveApiAssetUrl(m.file_url)} alt={m.file_name || 'media'} />
                            </button>
                        ))}
                    </div>
                ) : (
                    <div className="chat-room-info__empty">Медиа пока нет</div>
                )}
            </div>
        </aside>
    )
}
